import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical, MessageSquareText, Shapes } from 'lucide-react';
import { useI18n } from '../../i18n/I18nContext';
import './Testimonials.css';

const POINT_ICONS = [Shapes, FlaskConical, MessageSquareText];

const Testimonials: React.FC = () => {
  const { content } = useI18n();
  const testimonials = content.testimonials;
  return (
    <section className="testimonials section" aria-label={testimonials.aria}>
      <div className="container">
        <div className="testimonials__intro"><h2>{testimonials.title}</h2><p>{testimonials.intro}</p></div>
        <div className="testimonials__grid">
          {testimonials.points.map((point, index) => {
            const Icon = POINT_ICONS[index];
            return <article key={point.title}><span><Icon size={19} strokeWidth={1.7} /></span><h3>{point.title}</h3><p>{point.description}</p></article>;
          })}
        </div>
        <div className="testimonials__actions">
          <Link to="/request" className="btn btn-primary">{testimonials.primary}</Link>
          <Link to="/contact" className="btn btn-outline">{testimonials.secondary}</Link>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
